export type ThemeMode = 'light' | 'dark'

export const lightColors = {
  primary: '#4F46E5',
  primarySolid: '#4F46E5',
  primaryLight: '#6366F1',
  secondary: '#7C3AED',
  secondaryLight: '#8B5CF6',
  background: '#F8FAFC',
  surface: '#FFFFFF',
  surfaceHover: '#FAFAFC',
  text: '#0F172A',
  textSecondary: '#64748B',
  textMuted: '#94A3B8',
  textPlaceholder: '#CBD5E1',
  border: '#E2E8F0',
  borderLight: '#F1F5F9',
  borderHover: '#CBD5E1',
  success: '#10B981',
  successLight: '#D1FAE5',
  successText: '#047857',
  error: '#EF4444',
  errorLight: '#FEE2E2',
  errorText: '#B91C1C',
  warning: '#F59E0B',
  warningLight: '#FEF3C7',
  warningText: '#92400E',
  info: '#3B82F6',
  infoLight: '#DBEAFE',
  infoText: '#1D4ED8',
  brandNavy: '#151c55',
  brandOrange: '#ff6b00',
}

export const darkColors: typeof lightColors = {
  primary: '#B1A7FF',
  primarySolid: '#6353D9',
  primaryLight: '#C4BCFF',
  secondary: '#BAA4FF',
  secondaryLight: '#D1BDFF',
  background: '#10141F',
  surface: '#191F2E',
  surfaceHover: '#222A3D',
  text: '#E5E9F0',
  textSecondary: '#B1BDD0',
  textMuted: '#9AA9BE',
  textPlaceholder: '#8796AC',
  border: '#354056',
  borderLight: '#2A3348',
  borderHover: '#64748B',
  success: '#5BD6A1',
  successLight: '#173D35',
  successText: '#5BD6A1',
  error: '#FF8F91',
  errorLight: '#452A35',
  errorText: '#FF8F91',
  warning: '#F2BB6B',
  warningLight: '#423722',
  warningText: '#F2BB6B',
  info: '#80B6FF',
  infoLight: '#213552',
  infoText: '#80B6FF',
  brandNavy: '#E5E9F0',
  brandOrange: '#ff8b38',
}

export const themeColors = { light: lightColors, dark: darkColors }

export function themeColorVariables(mode: ThemeMode): Record<string, string> {
  return Object.fromEntries(
    Object.entries(themeColors[mode]).map(([name, value]) => [`--apex-color-${name}`, value]),
  )
}
